import React from 'react';

export default function KeyStroke({ keystroke, color }) {
  return (
    <div id={`exppanel-keystroke-${keystroke}-wrapper`}
      style={{
        color: `rgb(${color})`,
        fontSize: '2rem',
        minWidth: '100%',
        fontWeight: 'bold',
        height: '60%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {keystroke}
    </div>
  );
}
